export const dbName = 'seppanen-ops-database'
export const dbVersion = import.meta.env.VITE_DATABASE_VERSION || 1
